export type PeopleCompaniesDatabaseMetaInput = {
  tab: string;
  /** Pagination / match count for the current list query. */
  listTotal: number;
  /** Full Database Entity count including Child Database Entities. */
  databaseTotalEntities: number | null | undefined;
  hasSearchOrFilters: boolean;
};

/** A database type as the header names it: `people & companies` → `People & companies`. */
export function databaseTypeLabel(type: string): string {
  return type.charAt(0).toUpperCase() + type.slice(1);
}

/**
 * Header meta for people & companies database detail, under the page title.
 * Plain All tab shows full Database Entity count (and top-level when hierarchies exist).
 * Search, filters, and status tabs show the current list match count only.
 */
const LABEL = databaseTypeLabel('people & companies');

export function formatPeopleCompaniesDatabaseMeta(
  input: PeopleCompaniesDatabaseMetaInput,
): string {
  const {
    tab,
    listTotal,
    databaseTotalEntities,
    hasSearchOrFilters,
  } = input;

  const isPlainAllTab =
    tab.toLowerCase() === 'all' && !hasSearchOrFilters;

  if (!isPlainAllTab) {
    return `${LABEL} · ${listTotal} entities`;
  }

  const total =
    databaseTotalEntities !== null && databaseTotalEntities !== undefined
      ? databaseTotalEntities
      : listTotal;

  if (total > listTotal) {
    return `${LABEL} · ${total} entities · ${listTotal} top-level`;
  }

  return `${LABEL} · ${total} entities`;
}
